import { ReactNode } from 'react';
import easeEmoji from 'react-easy-emoji';

const emoji = (text: string): ReactNode => easeEmoji(text);

export default emoji;
